export default __webpack_public_path__ + "resources/icons/n141-4e7a.webp";